import React, { useState } from 'react';
import { User } from 'firebase/auth';

interface HeaderProps {
  user: User | null;
  onLogout: () => void;
  onShowSettings: () => void;
}

const Header: React.FC<HeaderProps> = ({ user, onLogout, onShowSettings }) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <header className="App-header">
      <nav className="navbar navbar-expand-lg">
        <div className="container py-2">
          <a className="navbar-brand d-flex align-items-center" href="/">
            <img src="/logo.png" alt="Logo" style={{ height: '32px', marginRight: '10px' }} />
            <span className="fw-bold text-white">
              <span style={{ color: '#3b82f6' }}>AI</span> ShoppingCart
            </span>
          </a>

          <button
            className="navbar-toggler border-0 shadow-none"
            type="button"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            aria-controls="navbarNav"
            aria-expanded={isMenuOpen}
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon" style={{ filter: 'invert(1)' }}></span>
          </button>

          <div className={`collapse navbar-collapse ${isMenuOpen ? 'show' : ''}`} id="navbarNav">
            <ul className="navbar-nav ms-auto align-items-center">
              {user && (
                <li className="nav-item ms-lg-4 mt-3 mt-lg-0">
                  <div className="d-flex align-items-center bg-white bg-opacity-10 p-1 pe-2 ps-1 rounded-pill border border-white border-opacity-10">
                    <div className="bg-primary bg-opacity-20 text-primary rounded-circle d-flex align-items-center justify-content-center me-2" style={{ width: '32px', height: '32px' }}>
                      <i className="bi bi-person-fill"></i>
                    </div>
                    <div className="text-start pe-2">
                      <span className="fw-semibold text-truncate d-inline-block text-white" style={{ maxWidth: '100px', fontSize: '0.85rem' }}>{user.displayName}</span>
                    </div>
                    <div className="d-flex gap-1 ms-auto">
                      <button className="btn btn-outline-light btn-sm border-0 rounded-circle p-0 opacity-75 hover-opacity-100" onClick={onShowSettings} title="Settings" style={{ width: '28px', height: '28px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                        <i className="bi bi-gear" style={{ fontSize: '0.85rem' }}></i>
                      </button>
                      <button className="btn btn-link btn-sm text-danger border-0 rounded-circle p-0" onClick={onLogout} title="Logout" style={{ width: '28px', height: '28px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                        <i className="bi bi-box-arrow-right" style={{ fontSize: '0.85rem' }}></i>
                      </button>
                    </div>
                  </div>
                </li>
              )}
            </ul>
          </div>
        </div>
      </nav>
    </header>
  );
};

export default Header;
